import en from "./localize/en.json";
import id from "./localize/id.json";

export default {
  en,
  id,
};
